import { Link } from 'react-router-dom';

export default function PageHeader({ backTo, backLabel = 'Dashboard', title, children }) {
  return (
    <div className="page-subheader">
      <Link to={backTo} className="back-link">
        &larr; {backLabel}
      </Link>
      <h1 className="page-subheader-title">{title}</h1>
      {children && <div className="page-subheader-actions">{children}</div>}
    </div>
  );
}
